export const appImageMaterialsIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" rx="2" fill="#FFCA03"/><circle cx="14.5" cy="9.5" r="1.5" fill="white"/><path d="M10.6567 10L6 16H18L14.7761 11.92L13.5224 13.2L10.6567 10Z" fill="white"/></svg>`,
    name: 'image-materials'
};